var App = App || {};

App.Disclaimers = (function ($) {
    "use strict";

    function init() {
        var footerDisclaimersToggle = $(".site-footer-disclaimers-toggle"),
            toggleText = footerDisclaimersToggle.find(".text"),
            toggleIcon = footerDisclaimersToggle.find(".fa"),
            addnlDisclaimers = $(".site-footer-disclaimers .addnl-disclaimers"),
            addnlDisclaimerLinks = addnlDisclaimers.find("a"),
            itemsWrapper = $(".site-footer-disclaimers .addnl-disclaimers").find(".items-wrapper");

        addnlDisclaimerLinks.attr("tabindex", "-1");

        footerDisclaimersToggle.on("click", function () {
            if (addnlDisclaimers.hasClass("collapsed")) {
                addnlDisclaimers.removeClass("collapsed").css("max-height", "calc(" + itemsWrapper.outerHeight(true) + "px + 2rem");
                toggleText[0].innerHTML = "Hide Disclosures";
                toggleIcon.removeClass("fa-plus").addClass("fa-minus");
                addnlDisclaimerLinks.attr("tabindex", "0");
            }
            else {
                addnlDisclaimers.addClass("collapsed").css("max-height", 0);
                toggleText[0].innerHTML = "Show All";
                toggleIcon.addClass("fa-plus").removeClass("fa-minus");
                addnlDisclaimerLinks.attr("tabindex", "-1");
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Disclaimers.init();
});